var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBukIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 296 c-16 -13 -19 -29 -22 -131 -5 -167 -7 -165 157 -165 165 0 161 -4 161 151 0 161 2 159 -154 159 -90 0 -127 -4 -142 -14z m61 -116 c35 0 51 -34 30 -66 -32 -49 -66 -22 -64 50 1 28 3 43 6 34 3 -11 14 -18 28 -18z m155 -30 c4 0 10 7 14 15 3 8 10 15 16 15 7 0 8 -6 2 -17 -7 -11 -6 -23 1 -34 6 -10 8 -22 3 -26 -4 -4 -12 0 -17 10 -13 22 -26 22 -32 0 -3 -10 -4 9 -4 42 0 33 2 45 4 28 2 -18 8 -33 13 -33z m-74 -30 c12 -11 14 -7 14 24 0 20 5 36 10 36 6 0 10 -18 10 -40 0 -38 -2 -40 -30 -40 -29 0 -30 2 -29 43 2 28 3 33 6 15 2 -14 11 -32 19 -38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 150 c-4 -6 -1 -17 5 -26 15 -18 42 0 33 22 -6 16 -29 19 -38 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBukIcon);
export default __webpack_public_path__ + "static/media/buk_icon.4a70d396b2ab8112ac87756b11e17f02.svg";
export { ForwardRef as ReactComponent };